import { AxiosInstance } from 'axios';
import qs from 'qs';
import {
    AddUserNotificationEmailInput,
    ClaimUserNotificationEmailVerificationInput,
    UpdateUserNotificationEmailInput,
    UserNotificationEmailFilterInput,
} from './inputs';
import { CollectionResource } from '@app/data/resources';
import { UserNotificationEmailResource } from './resources';
import { UserNotificationEmailRef } from './refs';

export default class UserNotificationEmail {
    private basePath = '/api/user-notification-email';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetch list of user notification emails by user ID
    get = async (
        filter: UserNotificationEmailFilterInput,
    ): Promise<CollectionResource<UserNotificationEmailResource, {}>> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Add new user notification email
    add = async (input: AddUserNotificationEmailInput): Promise<UserNotificationEmailRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Update user notification email
    update = async (id: ID, input: UpdateUserNotificationEmailInput): Promise<UserNotificationEmailRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Remove user notification email
    remove = async (id: ID): Promise<UserNotificationEmailRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Generate verification code
    generateVerificationCode = async (id: ID): Promise<UserNotificationEmailRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/verification`);

        return data;
    };

    // Verify by verification code claim
    verifyByCodeClaim = async (id: ID, input: ClaimUserNotificationEmailVerificationInput): Promise<UserNotificationEmailRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/verification/claim`, input);

        return data;
    };

    // Manually verify
    verify = async (id: ID): Promise<UserNotificationEmailRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/verification`);

        return data;
    };

    // Remove verification status
    removeVerification = async (id: ID) => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/verification`);

        return data;
    };
}
